import { useLocation } from "react-router-dom";

import { SETTINGS_ROUTES } from "@src/routes/routes";

import type { BillingModuleGateDecision } from "./PricingGatedModal.types";
import { getPricingGatedModalViewModel } from "./PricingGatedModal.viewModel";
import { PricingGatedModalView } from "./PricingGatedModal.view";

type PricingGatedModalControllerProps = {
  decision: BillingModuleGateDecision;
  moduleId: string;
  open: boolean;
  onClose: () => void;
  onContinueToPayment?: () => void;
};

export const PricingGatedModalController = ({
  decision,
  moduleId,
  open,
  onClose,
  onContinueToPayment,
}: PricingGatedModalControllerProps) => {
  const { pathname } = useLocation();
  const isOnBillingPage = pathname.includes(SETTINGS_ROUTES.Settings);

  const viewModel = getPricingGatedModalViewModel({
    decision,
    isOnBillingPage,
    moduleId,
    onClose,
    onContinueToPayment,
  });

  if (!viewModel) return null;

  return <PricingGatedModalView open={open} onClose={onClose} {...viewModel} />;
};
